import { useCallback } from "react";
import { useMutation } from "@apollo/client";
import { GET_CART, SET_ORDER_NOTE } from "../queries/cart";

const useSetOrderNote = () => {
    const [mutation, { loading }] = useMutation(SET_ORDER_NOTE);

    const setOrderNote = useCallback((variables) => {
        return mutation({
            variables: {
                ...variables
            },
        });
    }, [mutation]);

    return {
        setOrderNote,
        loading,
    };
};

export default useSetOrderNote;
